import Vue from "vue";
import i18n from "../i18n";

export default {
  async doLogin({ commit }, payload) {
    let rsp = await Vue.axios.post(Vue.$url("login/doLogin"), payload);
    commit("mLogin", rsp.data);
  },

  doLogout({ commit }) {
    commit("mLogout");
  },

  async checkWinAuth({ commit }) {
    Vue.$log.debug("checking if user is already Windows authenticated ....");
    let rsp = await Vue.axios.get(Vue.$url("login/win-auth"));
    commit("SET_WIN_SUPPORTED_AUTH", rsp.data);
    return rsp.data;
  },

  async checkMicrosoftAuth({ commit }) {
    Vue.$log.debug("checking if user is already Microsoft AD authenticated ....");
    let rsp = await Vue.axios.get(Vue.$url("login/check"), { withCredentials: true });
    commit("mLogin", rsp.data);
  },

  async loadVesselNames({ commit }, payload) {
    let vesselNames = await Vue.axios.get(Vue.$url("vessel/names"), payload);
    commit("mVesselNames", vesselNames.data);
  },

  async loadProjectsNames({ commit }, payload) {
    let projectsNames = await Vue.axios.get(Vue.$url("project/names"), payload);
    commit("mProjectsNames", projectsNames.data);
  },

  async loadVesselNamesByProject({ commit }, projectId) {
    let rsp = await Vue.axios.get(Vue.$url("project/" + projectId + "/vessels"));
    commit("SET_PROJECT_VESSELS", rsp.data);
  },

  async fetchProjectVesselMappings({ commit }) {
    Vue.$log.debug("fetchProjectVesselMappings");
    return Vue.axios.get(Vue.$url("project-vessel")).then((rsp) => {
      commit("SET_PROJECT_VESSELS_MAPPINGS", rsp.data);
      return rsp.data;
    });
  },

  // async loadMaxCode({ commit }, { tableName, code }) {
  //   let maxedCode = await Vue.axios.get(Vue.$url("login/getMaxCode/" + tableName), code);
  //   commit("mMaxCode", maxedCode.data);
  // },

  // /** @deprecated */
  // async loadProjectsNames({ commit }, payload) {
  //   let projectsNames = await Vue.axios.get(Vue.$url("project/names"), payload);
  //   commit("mProjectsNames", projectsNames.data);
  // },

  //#region Activity Types

  // async createActivityType({ dispatch, commit }, { model, payload }) {
  //   return Vue.axios
  //     .post(Vue.$url("activity-type"), model, payload)
  //     .then((data) => {
  //       Vue.$log.debug("actvity type created and saved under", data.id);
  //       commit('mShowInfoMessage', i18n.t('common.saved', { 0: 'ActivityType', 1: model.description }));
  //       dispatch('loadActivityTypes');
  //       dispatch('getActivityTypeMaxCode');
  //     })
  //     .catch((err) => {
  //       Vue.$err(err);
  //       commit('mShowErrorMessage', err.data.Message);
  //     })
  // },

  // async loadActivityTypes({ commit }, payload) {
  //   return Vue.axios.get(Vue.$url("activity-type"), payload)
  //     .then((rsp) => {
  //       commit("mActivityType", rsp.data);
  //     })
  //     .catch((err) => {
  //       Vue.$err(err);
  //       commit('mShowErrorMessage', err.data.Message);
  //     })
  // },

  // async getActivityTypeMaxCode({ commit }, payload) {
  //   let rsp = await Vue.axios.get(Vue.$url("activity-type/max-code"), payload);
  //   let nextSeq = rsp.data;
  //   commit("mMaxCode", nextSeq);
  //   commit("mNextSeqCode", { payload: nextSeq, entity: 'activityType' });
  // },

  // async deleteActivityType({ dispatch, commit }, payload) {
  //   Vue.$log.debug('trying to delete ActivityType', payload.id);
  //   return Vue.axios
  //     .delete(Vue.$url("activity-type/" + payload.id))
  //     .then(() => {
  //       commit('mShowInfoMessage', i18n.t('common.lockupdate', { 0: payload.description }));
  //       dispatch('loadActivityTypes');
  //     })
  //     .catch((err) => {
  //       Vue.$err(err);
  //       commit('mShowErrorMessage', err.data.Message);
  //     });
  // },

  // async updateActivityType({ dispatch, commit }, { model, payload }) {
  //   return Vue.axios
  //     .put(Vue.$url("activity-type/" + model.id), model, payload)
  //     .then(() => {
  //       commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'ActivityType', 1: model.description }));
  //       dispatch('loadActivityTypes');
  //     })
  //     .catch((err) => {
  //       Vue.$err(err);
  //       commit('mShowErrorMessage', err.data.Message);
  //     });
  // },

  //#endregion

  //#region Activity Master
  // async createActivityMaster({ dispatch, commit }, { model, payload }) {
  //   return Vue.axios.post(Vue.$url("activity"), model, payload)
  //     .then((data) => {
  //       Vue.$log.debug("actvity created and saved under", data.id);
  //       commit('mShowInfoMessage', i18n.t('common.saved', { 0: 'Activity', 1: model.description }));
  //       dispatch('loadActivities');
  //       dispatch('getActivityMaxCode');
  //     })
  // },

  // async getActivityMaxCode({ commit }, payload) {
  //   let rsp = await Vue.axios.get(Vue.$url("activity/max-code"), payload);
  //   let nextSeq = rsp.data;
  //   commit("mMaxCode", nextSeq);
  //   commit("mNextSeqCode", { payload: nextSeq, entity: 'activity' });
  // },

  // async loadActivities({ commit }, payload) {
  //   return Vue.axios.get(Vue.$url("activity"), payload)
  //     .then((rsp) => {
  //       commit("mActivityMaster", rsp.data);
  //     })
  // },

  // async deleteActivityMaster({ dispatch, commit }, payload) {
  //   Vue.$log.debug('trying to delete activity', payload.id)
  //   return Vue.axios.delete(Vue.$url("activity/" + payload.id))
  //     .then(() => {
  //       commit('mShowInfoMessage', i18n.t('common.lockupdate', { 0: payload.description }));
  //       dispatch('loadActivities');
  //     });
  // },

  // async updateActivityMaster({ dispatch, commit }, { model, payload }) {
  //   return Vue.axios.put(Vue.$url("activity/" + model.id), model, payload)
  //     .then(() => {
  //       commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'Activity', 1: model.description }));
  //       dispatch('loadActivities');
  //     })
  // },
  //#endregion

  //#region Activity Categories
  // async createActivityCategories({ dispatch, commit }, { model, payload }) {
  //   return Vue.axios.post(Vue.$url("activity-category"), model, payload)
  //     .then((data) => {
  //       Vue.$log.debug("actvity category created and saved under", data.id);
  //       commit('mShowInfoMessage', i18n.t('common.saved', { 0: 'ActivityCategory', 1: model.description }));
  //       dispatch('loadActivityCategories');
  //       dispatch('getActivityCategoryMaxCode');
  //     })
  //     .catch((err) => {
  //       Vue.$err(err);
  //       commit('mShowErrorMessage', err.data.Message);
  //     })
  // },

  // async getActivityCategoryMaxCode({ commit }, payload) {
  //   let rsp = await Vue.axios.get(Vue.$url("activity-category/max-code"), payload);
  //   let nextSeq = rsp.data;
  //   commit("mMaxCode", nextSeq);
  //   commit("mNextSeqCode", { payload: nextSeq, entity: 'activityCategory' });
  // },

  // async loadActivityCategories({ commit }, payload) {
  //   return Vue.axios.get(Vue.$url("activity-category"), payload)
  //     .then((rsp) => {
  //       commit("mActivityCategory", rsp.data);
  //     })
  //     .catch((err) => {
  //       Vue.$err(err);
  //       commit('mShowErrorMessage', err.data.Message);
  //     })
  // },

  // async deleteActivityCategories({ dispatch, commit }, payload) {
  //   Vue.$log.debug('trying to delete activity category', payload.id);
  //   return Vue.axios.delete(Vue.$url("activity-category/" + payload.id))
  //     .then(() => {
  //       commit('mShowInfoMessage', i18n.t('common.lockupdate', { 0: payload.description }));
  //       dispatch('loadActivityCategories');
  //     })
  //     .catch((err) => {
  //       Vue.$err(err);
  //       commit('mShowErrorMessage', err.data.Message);
  //     });
  // },

  // async updateActivityCategories({ dispatch, commit }, { model, payload }) {
  //   return Vue.axios.put(Vue.$url("activity-category/" + model.id), model, payload)
  //     .then(() => {
  //       commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'ActivityCategory', 1: model.description }));
  //       dispatch('loadActivityCategories');
  //     })
  //     .catch((err) => {
  //       Vue.$err(err);
  //       commit('mShowErrorMessage', err.data.Message);
  //     })
  // },

  //#endregion

  //#region Project

  /** @deprecated */
  async getProjectMaxCode({ commit }, payload) {
    let rsp = await Vue.axios.get(Vue.$url("project/max-code"), payload);
    let nextSeq = rsp.data;
    commit("mMaxCode", nextSeq);
    commit("mNextSeqCode", { payload: nextSeq, entity: "project" });
  },

  async updateProject({ dispatch, commit }, { model, payload }) {
    return Vue.axios
      .put(Vue.$url("project/" + model.id), model, payload)
      .then(() => {
        commit("mShowInfoMessage", i18n.t("common.updated", { 0: "Project", 1: model.projectName }));
        dispatch("loadProjects");
      })
      .catch((err) => {
        Vue.$err(err);
        commit("mShowErrorMessage", err.data.Message);
      });
  },

  // ---- TO BE REFACTORED

  async loadProjects({ commit }, payload) {
    let projects = await Vue.axios.get(Vue.$url("project"), payload);
    commit("mProjects", projects.data);
  },
  async loadProjectById({ commit }, { id, payload }) {
    let project = await Vue.axios.get(Vue.$url("project/" + id), payload);
    Vue.$log.debug("loadProjectById response", JSON.stringify(project.data, null, 2));
    commit("mProject", project.data);
  },

  /** @deprecated */
  async createProject({ commit }, { model, payload }) {
    let itemAfterCreate = await Vue.axios.post(Vue.$url("project"), model, payload);
    commit("mProjects", itemAfterCreate.data);
  },

  async deleteProject({ commit }, { id, payload }) {
    let itemAfterDelete = await Vue.axios.delete(Vue.$url("project/" + id), payload);
    commit("mProjects", itemAfterDelete.data);
  },

  // async loadProjectsInVessel({ commit }, payload) {
  //   let projects = await Vue.axios.get(Vue.$url("projectinvessel"), payload);
  //   commit("mProjectsInVessel", projects.data);
  // },
  // async createProjectsInVessel({ commit }, { model, payload }) {
  //   let itemAfterCreate = await Vue.axios.post(Vue.$url("projectinvessel"), model, payload);
  //   commit("mProjectsInVessel", itemAfterCreate.data);
  // },
  // async updateProjectInVessel({ commit }, { model, payload }) {
  //   let itemAfterUpdate = await Vue.axios.put(Vue.$url("projectinvessel"), model, payload);
  //   commit("mProjectsInVessel", itemAfterUpdate.data);
  // },
  // async deleteProjectInVessel({ commit }, { model, payload }) {
  //   let itemAfterDelete = await Vue.axios.delete(Vue.$url("projectinvessel"), model, payload);
  //   commit("mProjectsInVessel", itemAfterDelete.data);
  // },

  async loadUnassignedVessels({ commit }, payload) {
    let rsp = await Vue.axios.get(Vue.$url("project/vessellist"), payload);
    Vue.$log.debug("loaded all unassigned vessels", rsp.data);
    commit("mUnassignedVessels", rsp.data);
  },

  /** @deprecated */
  async loadProjectStatuses({ commit }, payload) {
    let rsp = await Vue.axios.get(Vue.$url("project/status-list"), payload);
    Vue.$log.debug("loaded project statuses", rsp.data);
    commit("SET_PROJECT_STATUSES", rsp.data);
  },

  //#endregion

  //#region Cables

  // async createCable({ dispatch, commit }, { model, payload }) {
  //   return Vue.axios
  //     .post(Vue.$url("cable"), model, payload)
  //     .then((data) => {
  //       Vue.$log.debug("cable created and saved under", data.id);
  //       commit('mShowInfoMessage', i18n.t('common.saved', { 0: 'Cable', 1: model.description }));
  //       dispatch('loadCables');
  //     })
  // },

  // async loadCables({ commit }, payload) {
  //   return Vue.axios.get(Vue.$url("cable?pId=&vId="), payload)
  //     .then((rsp) => {
  //       commit("mCable", rsp.data);
  //     })
  // },

  // async deleteCable({ dispatch, commit }, payload) {
  //   Vue.$log.debug('trying to delete Cable', payload.id);
  //   return Vue.axios
  //     .delete(Vue.$url("cable/" + payload.id))
  //     .then(() => {
  //       commit('mShowInfoMessage', i18n.t('common.lockupdate', { 0: payload.description }));
  //       dispatch('loadCables');
  //     });
  // },

  // async updateCable({ dispatch, commit }, { model, payload }) {
  //   return Vue.axios
  //     .put(Vue.$url("cable/" + model.id), model, payload)
  //     .then(() => {
  //       commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'Cable', 1: model.description }));
  //       dispatch('loadCables');
  //     });
  // },

  //#endregion

  //#region Configurations

  // async createConfiguration({ dispatch, commit }, { model, payload }) {
  //   return Vue.axios
  //     .post(Vue.$url("configuration"), model, payload)
  //     .then((data) => {
  //       Vue.$log.debug("configuration created and saved under", data.id);
  //       commit('mShowInfoMessage', i18n.t('common.saved', { 0: 'Configuration', 1: model.description }));
  //       dispatch('loadConfigurations');
  //     })
  //     .catch((err) => {
  //       Vue.$err(err);
  //       commit('mShowErrorMessage', err.data.Message);
  //     })
  // },

  // async loadConfigurations({ commit }, payload) {
  //   return Vue.axios.get(Vue.$url("configuration"), payload)
  //     .then((rsp) => {
  //       commit("mConfigurations", rsp.data);
  //     })
  //     .catch((err) => {
  //       Vue.$err(err);
  //       commit('mShowErrorMessage', err.data.Message);
  //     })
  // },

  // async deleteConfiguration({ dispatch, commit }, payload) {
  //   Vue.$log.debug('trying to delete Configuration', payload.id);
  //   return Vue.axios
  //     .delete(Vue.$url("configuration/" + payload.id))
  //     .then(() => {
  //       commit('mShowInfoMessage', i18n.t('common.lockupdate', { 0: payload.description }));
  //       dispatch('loadConfigurations');
  //     })
  //     .catch((err) => {
  //       Vue.$err(err);
  //       commit('mShowErrorMessage', err.data.Message);
  //     });
  // },

  // async updateConfiguration({ dispatch, commit }, { model, payload }) {
  //   return Vue.axios
  //     .put(Vue.$url("configuration/" + model.id), model, payload)
  //     .then(() => {
  //       commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'Configuration', 1: model.description }));
  //       dispatch('loadConfigurations');
  //     })
  //     .catch((err) => {
  //       Vue.$err(err);
  //       commit('mShowErrorMessage', err.data.Message);
  //     });
  // },

  //#endregion

  //#region Equipment Status

  // async createEquipmentStatus({ dispatch, commit }, { model, payload }) {
  //   return Vue.axios
  //     .post(Vue.$url("equipment-status"), model, payload)
  //     .then((data) => {
  //       Vue.$log.debug("Equipment status created and saved under", data.id);
  //       commit('mShowInfoMessage', i18n.t('common.saved', { 0: 'EquipmentStatus', 1: model.description }));
  //       dispatch('loadEquipmentStatus');
  //     })
  // },

  // async loadEquipmentStatus({ commit }, payload) {
  //   return Vue.axios.get(Vue.$url("equipment-status?pId=&vId"), payload)
  //     .then((rsp) => {
  //       commit("mEquipmentStatus", rsp.data);
  //     })
  // },

  // async deleteEquipmentStatus({ dispatch, commit }, payload) {
  //   Vue.$log.debug('trying to delete EquipmentStatus', payload.id);
  //   return Vue.axios
  //     .delete(Vue.$url("equipment-status/" + payload.id))
  //     .then(() => {
  //       commit('mShowInfoMessage', i18n.t('common.lockupdate', { 0: payload.description }));
  //       dispatch('loadEquipmentStatus');
  //     });
  // },

  // async updateEquipmentStatus({ dispatch, commit }, { model, payload }) {
  //   return Vue.axios
  //     .put(Vue.$url("equipment-status/" + model.id), model, payload)
  //     .then(() => {
  //       commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'EquipmentStatus', 1: model.description }));
  //       dispatch('loadEquipmentStatus');
  //     });
  // },

  //#endregion

  //#region Estimates

  // async createEstimate({ dispatch, commit }, { model, payload }) {
  //   return Vue.axios
  //     .post(Vue.$url("estimate"), model, payload)
  //     .then((data) => {
  //       Vue.$log.debug("estimate created and saved under", data.id);
  //       commit('mShowInfoMessage', i18n.t('common.saved', { 0: 'Estimate', 1: model.description }));
  //       dispatch('loadEstimates');
  //     })
  // },

  // async loadEstimates({ commit }, payload) {
  //   return Vue.axios.get(Vue.$url("estimate"), payload)
  //     .then((rsp) => {
  //       commit("mEstimates", rsp.data);
  //     })
  // },

  // async deleteEstimate({ dispatch, commit }, payload) {
  //   Vue.$log.debug('trying to delete Estimate', payload.id);
  //   return Vue.axios
  //     .delete(Vue.$url("estimate/" + payload.id))
  //     .then(() => {
  //       commit('mShowInfoMessage', i18n.t('common.lockupdate', { 0: payload.description }));
  //       dispatch('loadEstimates');
  //     });
  // },

  // async updateEstimate({ dispatch, commit }, { model, payload }) {
  //   return Vue.axios
  //     .put(Vue.$url("estimate/" + model.id), model, payload)
  //     .then(() => {
  //       commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'Estimate', 1: model.description }));
  //       dispatch('loadEstimates');
  //     });
  // },

  //#endregion

  //#region Qhses

  // async createQhse({ dispatch, commit }, { model, payload }) {
  //   return Vue.axios
  //     .post(Vue.$url("qhse"), model, payload)
  //     .then((data) => {
  //       Vue.$log.debug("qhse created and saved under", data.id);
  //       commit('mShowInfoMessage', i18n.t('common.saved', { 0: 'Qhse', 1: model.description }));
  //       dispatch('loadQhse');
  //     })
  //     .catch((err) => {
  //       Vue.$err(err);
  //       commit('mShowErrorMessage', err.data.Message);
  //     })
  // },

  // async loadQhse({ commit }, payload) {
  //   return Vue.axios.get(Vue.$url("qhse"), payload)
  //     .then((rsp) => {
  //       commit("mQhse", rsp.data);
  //     })
  //     .catch((err) => {
  //       Vue.$err(err);
  //       commit('mShowErrorMessage', err.data.Message);
  //     })
  // },

  // async deleteQhse({ dispatch, commit }, payload) {
  //   Vue.$log.debug('trying to delete Qhse', payload.id);
  //   return Vue.axios
  //     .delete(Vue.$url("qhse/" + payload.id))
  //     .then(() => {
  //       commit('mShowInfoMessage', i18n.t('common.lockupdate', { 0: payload.description }));
  //       dispatch('loadQhse');
  //     })
  //     .catch((err) => {
  //       Vue.$err(err);
  //       commit('mShowErrorMessage', err.data.Message);
  //     });
  // },

  // async updateQhse({ dispatch, commit }, { model, payload }) {
  //   return Vue.axios
  //     .put(Vue.$url("qhse/" + model.id), model, payload)
  //     .then(() => {
  //       commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'Qhse', 1: model.description }));
  //       dispatch('loadQhse');
  //     })
  //     .catch((err) => {
  //       Vue.$err(err);
  //       commit('mShowErrorMessage', err.data.Message);
  //     });
  // },

  //#endregion

  //#region Area Masterdata

  // async createArea({ dispatch, commit }, { model, payload }) {
  //   return Vue.axios
  //     .post(Vue.$url("area"), model, payload)
  //     .then((data) => {
  //       Vue.$log.debug("area created and saved under", data.id);
  //       commit('mShowInfoMessage', i18n.t('common.saved', { 0: 'Area', 1: model.description }));
  //       dispatch('loadAreas');
  //     })
  //     .catch((err) => {
  //       Vue.$err(err);
  //       commit('mShowErrorMessage', err.data.Message);
  //     })
  // },

  // async loadAreas({ commit }, payload) {
  //   // XXX FIXME -- add pId & vId
  //   return Vue.axios.get(Vue.$url("area?pId=&vId="), payload)
  //     .then((rsp) => {
  //       commit("mAreas", rsp.data);
  //     })
  //     .catch((err) => {
  //       Vue.$err(err);
  //       commit('mShowErrorMessage', err.data.Message);
  //     })
  // },

  // async deleteArea({ dispatch, commit }, payload) {
  //   Vue.$log.debug('trying to delete Area', payload.id);
  //   return Vue.axios
  //     .delete(Vue.$url("area/" + payload.id))
  //     .then(() => {
  //       commit('mShowInfoMessage', i18n.t('common.lockupdate', { 0: payload.description }));
  //       dispatch('loadAreas');
  //     })
  //     .catch((err) => {
  //       Vue.$err(err);
  //       commit('mShowErrorMessage', err.data.Message);
  //     });
  // },

  // async updateArea({ dispatch, commit }, { model, payload }) {
  //   return Vue.axios
  //     .put(Vue.$url("area/" + model.id), model, payload)
  //     .then(() => {
  //       commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'Area', 1: model.description }));
  //       dispatch('loadAreas');
  //     })
  //     .catch((err) => {
  //       Vue.$err(err);
  //       commit('mShowErrorMessage', err.data.Message);
  //     });
  // },

  //#endregion

  //#region Computers
  async loadComputers({ commit }, payload) {
    return Vue.axios
      .get(Vue.$url("local-computer"), payload)
      .then((rsp) => {
        commit("mComputers", rsp.data);
      })
      .catch((err) => {
        Vue.$err(err);
        commit("mShowErrorMessage", err.Message);
      });
  },
  //#endregion

  //#region ProjectsInComputer

  async createProjectsInComputer({ dispatch, commit }, { model, payload }) {
    return Vue.axios.post(Vue.$url("project-in-computer"), model, payload).then((data) => {
      Vue.$log.debug("area created and saved under", data.id);
      commit("mShowInfoMessage", i18n.t("common.saved", { 0: "Assignment", 1: data.computerName }));
      dispatch("loadProjectsInComputer");
    });
  },

  async loadProjectsInComputer({ commit }, payload) {
    return Vue.axios.get(Vue.$url("project-in-computer"), payload).then((rsp) => {
      commit("mProjectsInComputer", rsp.data);
    });
  },

  async deleteProjectsInComputer({ dispatch, commit }, payload) {
    Vue.$log.debug("trying to delete ProjectsInComputer", payload.id);
    return Vue.axios.delete(Vue.$url("project-in-computer/" + payload.id)).then(() => {
      commit("mShowInfoMessage", i18n.t("common.lockupdate", { 0: payload.description }));
      dispatch("loadProjectsInComputer");
    });
  },

  //#endregion
};
